import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageContainer } from '@/components/layout/PageContainer'
import { Button } from '@/components/ui/button'
import { StorefrontSettingsGuard } from './StorefrontSettingsGuard'
import { PricingSettings } from './PricingSettings'

export function PricingSettingsPage() {
  const navigate = useNavigate()

  return (
    <StorefrontSettingsGuard>
      <PageContainer>
        <div className="p-6 space-y-6">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full"
              onClick={() => navigate('/storefront/settings')}
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div>
              <h2 className="text-2xl font-semibold">Pricing</h2>
              <p className="text-sm text-muted-foreground">
                Price lists, stock sources, and inventory display
              </p>
            </div>
          </div>

          <PricingSettings />
        </div>
      </PageContainer>
    </StorefrontSettingsGuard>
  )
}
